import React from "react";
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2'; // 1. Importe o SweetAlert2
import './planos.css';

function Planos() {
    const navigate = useNavigate();

    // Links do WhatsApp permanecem os mesmos
    const numeroWhatsapp = "5537999826905";
    const mensagemWhatsappteste = "Olá! Gostaria de solicitar uma demonstração.";
    const mensagemWhatsappcontratar = "Olá! Gostaria de contratar o sistema R6.";
    const linkWhatsappteste = `https://wa.me/${numeroWhatsapp}?text=${encodeURIComponent(mensagemWhatsappteste)}`;
    const linkWhatsappcontratar = `https://wa.me/${numeroWhatsapp}?text=${encodeURIComponent(mensagemWhatsappcontratar)}`;

    // Função para o botão "Começar a testar" (permanece a mesma)
    const handleTesteClick = () => {
        navigate('/app/novaconta', { state: { tipoPlano: 'teste' } });
    };

    // 2. Função para o botão "Assinar agora" ATUALIZADA
    const handleAssinaturaClick = () => {
        // Substitui o alert() por uma janela formatada do SweetAlert2
        Swal.fire({
            title: 'Próximo Passo',
            text: "Realize seu cadastro na próxima página e comece a utilizar o R6. Nosso time irá entrar em contato para a realização do pagamento.",
            icon: 'info',
            confirmButtonColor: '#2185c6', // Cor primária do seu tema
            confirmButtonText: 'Ok, realizar cadastro!'
        }).then((result) => {
            // 3. A navegação ocorre apenas se o usuário clicar no botão de confirmação
            if (result.isConfirmed) {
                navigate('/app/novaconta', { state: { tipoPlano: 'assinatura' } });
            }
        });
    };

    return (
        <section id="planos" className="py-5 bg-light">
            <div className="container">
                <div className="row text-center mb-5">
                    <div className="col">
                        <h1 className="display-4">Planos e Preços</h1>
                        <p className="lead">Comece sua avaliação gratuita. Não é necessário cartão de crédito.</p>
                    </div>
                </div>

                <div className="row justify-content-center g-4">
                    {/* Card: Teste Grátis */}
                    <div className="col-lg-4 col-md-6">
                        <div className="card h-100 shadow-sm">
                            <div className="card-header text-center py-3">
                                <h2 className="h4 fw-normal"><b>Teste Grátis</b></h2>
                            </div>
                            <div className="card-body d-flex flex-column">
                                <h2 className="card-title text-center mb-4">R$ 0,00<small className="text-muted"> /mês</small></h2>
                                <ul className="list-unstyled mb-4">
                                    <li className="mb-2 text-center"><i className="bi bi-check-circle-fill text-success me-2"></i>7 dias de teste</li>
                                    <li className="mb-2 text-center"><i className="bi bi-x-circle-fill text-danger me-2"></i>Suporte disponível durante o teste</li>
                                </ul>
                                <button className="btn btn-outline-primary mt-auto" onClick={handleTesteClick}>Começar a testar</button>
                            </div>
                            <div className="card-footer text-center">
                                <a href={linkWhatsappteste} target="_blank" rel="noopener noreferrer">Solicite uma demonstração</a>
                            </div>
                        </div>
                    </div>

                    {/* Card: Plano Representante (Recomendado) */}
                    <div className="col-lg-4 col-md-6">
                        <div className="card card-recommended h-100 shadow">
                            <div className="card-header text-white bg-primary text-center py-3">
                                <h2 className="h4 fw-normal"><b>Plano Representante</b></h2>
                                <span className="badge rounded-pill bg-light text-primary mt-2">Recomendado</span>
                            </div>
                            <div className="card-body d-flex flex-column">
                                <h2 className="card-title text-center mb-4">R$ 89,90<small className="text-muted"> /mês</small></h2>
                                <h6 className="card-title text-center mb-4">R$ 29,90<small className="text-muted"> /usuário adicional</small></h6>
                                <ul className="list-unstyled mb-4">
                                    <li className="mb-2 text-center"><i className="bi bi-check-circle-fill text-success me-2"></i>Suporte ilimitado</li>
                                    <li className="mb-2 text-center"><i className="bi bi-check-circle-fill text-success me-2"></i>Acesso completo às funcionalidades</li>
                                </ul>
                                <button className="btn btn-primary mt-auto" onClick={handleAssinaturaClick}>Assinar agora</button>
                            </div>
                            <div className="card-footer text-center">
                                <a href={linkWhatsappcontratar} target="_blank" rel="noopener noreferrer">Solicite uma demonstração</a>
                            </div>
                        </div>
                    </div>

                    {/* Card: Plano Produção (Em breve) */}
                    <div className="col-lg-4 col-md-6">
                        <div className="card h-100 shadow-sm border-0 bg-transparent">
                            <div className="card-header text-center py-3 bg-secondary text-white" style={{ opacity: 0.7 }}>
                                <h2 className="h4 fw-normal"><b>Plano Produção</b></h2>
                            </div>
                            <div className="card-body d-flex flex-column align-items-center justify-content-center bg-light" style={{ opacity: 0.6 }}>
                                <h2 className="card-title text-center mb-2 text-muted">Em breve</h2>
                                <p className="text-center text-muted">Novas funcionalidades para controle de produção.</p>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </section >
    );
}

export default Planos;